import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BookingComponent } from "./booking.component";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../../../app/freightconfirmation/app.sharemodule";
import { LayoutModule } from "../../../app/theme/layouts/layout.module";
import { RouterModule } from "@angular/router";
import { OnflyNetworkComponent } from "../../../app/Network/onfly-network/onfly-network.component";
import { OnflyNetworkModule } from "../../../app/Network/onfly-network/onfly-network.module";
import { OnflyDriverModule } from "../../../app/Fleet/onfly-driver/onfly-driver.module";
//add kevin 23/11/2020
import { WaypointsMapModule } from "../../../app/map/WaypointsMap/Waypoints.module";
//end
// import { LiveTrackingModule } from "../../LiveTracking/LiveTracking.module";
import { TooltipModule } from "primeng/tooltip";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { TripExpenseModule } from "../../trip-expense/trip-expense.module";
import { VahanModule } from "../vahan/vahan.module";
import { DocumentsharedModule } from "../../documentshared/documentshared.module";
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

@NgModule({
  imports: [
    TooltipModule,
    CommonModule,
    FormsModule,
    SharedModule,
    LayoutModule,
    RouterModule,
    OnflyNetworkModule,
    OnflyDriverModule,
    HttpClientModule,
    VahanModule,
    // add kevin 23/11/2020
    WaypointsMapModule,
    //end
    //added by vithujan 07-04-2023
    TripExpenseModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    DocumentsharedModule
    // LiveTrackingModule,
  ],
  providers: [TranslateConfigService],
  declarations: [BookingComponent],
  exports: [BookingComponent],
})
export class BookingSharedModule { }
